import { TFunction } from 'i18next';
import { ROUTES } from '@/constants/routes';

export const getSeoTitle = (
  title: string | null | undefined,
  asPath: string,
  t: TFunction
) => {
  if (
    asPath.includes(ROUTES.walletFinish) ||
    asPath.includes(ROUTES.yigimFinish)
  ) {
    return t('pages.wallet.success_title');
  }

  return title ?? t('common.default_seo_title');
};
